import GuideComponent from 'components/guideToAddProduct';
import Header from 'modules/header/wholesaler/main';

const Guide = () => {
  return (
    <>
      <Header title="راهنمای انتخاب فروش محصول " />
      <GuideComponent app="market" />
    </>
  );
};

export default Guide;
